import styled from '@emotion/styled'

import { RangeUIButton, RangeUIWrapper } from './Elements'
import { Color, theme } from '../../constants'
import { Div } from '../Div'
import { Text } from '../Text'

const VerticalRule = styled.hr(() => ({
  color: `${Color.GREY}`,
  height: '100%',
  margin: 0,
  padding: 0,
  width: 1,
}))

type RangeNavigatorProps = {
  label: string
  minWidth?: number
  onChange: (delta: -1 | 1) => void
}

export const RangeNavigator = (props: RangeNavigatorProps) => {
  return (
    <RangeUIWrapper>
      <RangeUIButton
        size="xs"
        onClick={() => props.onChange(-1)}
        icon="ChevronLeftIcon"
        design="white"
      />
      <VerticalRule />
      <Div styles={{ px: 1, display: 'flex', alignItems: 'center' }}>
        <Text
          bold
          noSelect
          fontSize={theme.font.size[6]}
          styles={{
            minWidth: props.minWidth ?? 140,
            textAlign: 'center',
            width: '100%',
          }}
        >
          {props.label}
        </Text>
      </Div>
      <VerticalRule />
      <RangeUIButton
        size="xs"
        onClick={() => props.onChange(1)}
        icon="ChevronRightIcon"
        design="white"
      />
    </RangeUIWrapper>
  )
}
